"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeHTTPStatus = exports.IkeRouteErrorCode = exports.VALIDATION_SUCCESS_MESSAGE = exports.VALIDATION_FAILED_MESSAGE = void 0;
exports.VALIDATION_FAILED_MESSAGE = 'Validation failed';
exports.VALIDATION_SUCCESS_MESSAGE = 'Validation success';
/**
 * Error codes for all public HTTP requests
 */
exports.IkeRouteErrorCode = {
    VALID: 'valid',
    UNAUTHORIZED: 'unauthorized',
    INVALID: 'invalid',
    MISSING: 'missing',
    MISSING_FIELD: 'missing_field',
    ALREADY_EXISTS: 'already_exists',
    UNSUPPORTED: 'unsupported',
    NOT_FOUND: 'not_found',
    LICENSE_REQUIRED: 'license_required',
};
/** Common HTTP status codes */
var IkeHTTPStatus;
(function (IkeHTTPStatus) {
    IkeHTTPStatus[IkeHTTPStatus["SUCCESS"] = 200] = "SUCCESS";
    IkeHTTPStatus[IkeHTTPStatus["CREATED"] = 201] = "CREATED";
    IkeHTTPStatus[IkeHTTPStatus["REDIRECT_PERMANENTLY"] = 301] = "REDIRECT_PERMANENTLY";
    IkeHTTPStatus[IkeHTTPStatus["REDIRECT_TEMPORARILY"] = 302] = "REDIRECT_TEMPORARILY";
    IkeHTTPStatus[IkeHTTPStatus["NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
    IkeHTTPStatus[IkeHTTPStatus["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    IkeHTTPStatus[IkeHTTPStatus["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    IkeHTTPStatus[IkeHTTPStatus["FORBIDDEN"] = 403] = "FORBIDDEN";
    IkeHTTPStatus[IkeHTTPStatus["NOT_FOUND"] = 404] = "NOT_FOUND";
    IkeHTTPStatus[IkeHTTPStatus["VALIDATION_FAILED"] = 422] = "VALIDATION_FAILED";
    IkeHTTPStatus[IkeHTTPStatus["SERVER_ERROR"] = 500] = "SERVER_ERROR";
})(IkeHTTPStatus || (exports.IkeHTTPStatus = IkeHTTPStatus = {}));
//# sourceMappingURL=route.response.js.map